document.addEventListener("DOMContentLoaded", function() {
    const collapsibleCards = document.querySelectorAll(".card-collapse");
    collapsibleCards.forEach((card)=>{
        const header = card.querySelector("h2");
        header.addEventListener("click", ()=>{
            card.classList.toggle("collapsed");
        });
    });
});

//# sourceMappingURL=enroll.26e51710.js.map
